const access_token = localStorage.getItem('customer_access_token');
import {Auth} from 'aws-amplify';

export default {
  namespaced: true,
  state: {
    accessToken: access_token
  },
  mutations: {
    setAccessToken (state, value) {
      state.accessToken = value;
      localStorage.setItem('customer_access_token', state.accessToken);
    }
  },
  actions: {
    removeAccessToken (state) {
      state.accessToken = null;
      localStorage.removeItem('customer_access_token');
      return Auth.signOut();
    }
  },
  getters: {}
};
